var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpiredIconGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48595 2 2 6.48595 2 12C2 17.514 6.48595 22 12 22C17.514 22 22 17.514 22 12C22 6.48595 17.514 2 12 2ZM12 20.5714C7.27373 20.5714 3.42857 16.7263 3.42857 12C3.42857 7.27373 7.27373 3.42857 12 3.42857C16.7263 3.42857 20.5714 7.27373 20.5714 12C20.5714 16.7263 16.7263 20.5714 12 20.5714Z",
    fill: "#ADB8CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16L16 8",
    stroke: "#ADB8CC",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8L16 16",
    stroke: "#ADB8CC",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiredIconGrey);
export default __webpack_public_path__ + "static/media/expired_icon_grey.c0d3fdb4c285d239c4d0f3fe778e0040.svg";
export { ForwardRef as ReactComponent };